import { Button, IconButton, List } from "@material-ui/core";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Select from "react-select";
import { selectorStyle } from "../../../meetingEditor/layout/other/EventSelector";
import { Col, Row } from "reactstrap";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import BuildIcon from "@material-ui/icons/Build";
import ContentEditable from "react-contenteditable";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  typography: {
    marginBottom: "0.5rem",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export const PresetList = (props) => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const classes = useStyles();
  const { layouts, events, presets, isSavable, setSelectedPresetId, addPreset, activatePreset, deletePreset, deletePresetItem, addPresetItem, savePresets, onEditPreset } = props;
  return (
    <div style={{ padding: "0px 15px" }}>
      <Row>
        <Col>
          <Typography className={classes.typography + " primary-text bold"}>
            <SystemLabel name="Presets" />
          </Typography>
        </Col>
      </Row>
      <List className="dark-scroll" style={{ maxHeight: "calc(100vh - 134px)", minHeight: "calc(100vh - 134px)", overflowY: "auto" }}>
        {presets.map((p, i) => {
          return (
            <Accordion key={i} expanded={expanded === "panel" + p.daPresetId} className="dark-l2" onChange={handleChange("panel" + p.daPresetId)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon className="primary-text" />} aria-controls={`panel${p.daPresetId}bh-content`} id={`panel${p.daPresetId}bh-header`}>
                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                  {expanded === "panel" + p.daPresetId ? (
                    <div style={{ display: "flex", width: "50%" }}>
                      <EditIcon className="secondary-text edit-prepend-icon" />
                      <ContentEditable
                        onClick={(e) => e.stopPropagation()}
                        /*     style={element.style.styleProps} */
                        /*    innerRef={this.contentEditable} */
                        style={{ background: "#50525d" }}
                        html={p.name}
                        className={classes.heading + " primary-text ce-p"}
                        onChange={(e) => onEditPreset(p.daPresetId, e.target.value)}
                        tagName="p"
                      />
                    </div>
                  ) : (
                    <Typography className={classes.heading + " primary-text"}>{p.name}</Typography>
                  )}
                  <div>
                    <Button startIcon={<DeleteIcon />} className="delete-dark-btn" style={{ marginRight: 5 }} onClick={() => deletePreset(p.daPresetId)}>
                      <SystemLabel name="Delete" />
                    </Button>
                    <Button startIcon={<PlayArrowIcon />} className="primary-dark-btn" disabled={!p.daPresetItems || p.daPresetItems.length == 0} onClick={() => activatePreset(p.daPresetId)}>
                      <SystemLabel name="Activate" />
                    </Button>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails style={{ display: "block", borderTop: "1px solid #dcdcdc1a", padding: "0px 0px 20px 0px" }}>
                <List>
                  <Row style={{ margin: 0, marginBottom: 10 }}>
                    <Col>
                      <Typography className={classes.heading + " primary-text bold"}>
                        <SystemLabel name="EventTarget" />
                      </Typography>
                    </Col>
                    <Col>
                      <Typography className={classes.heading + " primary-text bold"}>
                        <SystemLabel name="LayoutToActivate" />
                      </Typography>
                    </Col>
                    <Col></Col>
                  </Row>
                  {p.daPresetItems
                    ? p.daPresetItems.map((pp, i) => {
                        const layoutName = layouts.find((l) => l.meetingLayoutId == pp.meetingLayoutId)?.name;
                        const eventName = events.find((l) => l.eventId == pp.targetEventId)?.name;
                        return (
                          <Row key={pp.meetingLayoutId} style={{ margin: 0, marginBottom: 5 }}>
                            <Col>
                              <div className="preset-row">
                                <Typography className={classes.heading + " primary-text"}>{eventName}</Typography>
                              </div>
                            </Col>
                            <Col>
                              <div className="preset-row">
                                <Typography className={classes.heading + " primary-text"}> {layoutName}</Typography>
                              </div>
                            </Col>
                            <Col>
                              <Button startIcon={<DeleteIcon />} className="delete-dark-btn" onClick={() => deletePresetItem(pp.daPresetItemId)}>
                                <SystemLabel name="Delete" />
                              </Button>
                            </Col>
                          </Row>
                        );
                      })
                    : null}
                </List>

                <Row style={{ width: "100%", margin: 0 }}>
                  <Col>
                    <Select
                      className="jirango-select"
                      options={
                        events
                          ? events.map((t) => {
                              return { value: t.eventId, label: t.name };
                            })
                          : []
                      }
                      value={selectedEvent}
                      onChange={(opt) => {
                        const selEvent = events.find((e) => e.eventId == opt.value);
                        setSelectedEvent({ value: selEvent.eventId, label: selEvent.name });
                      }}
                      styles={selectorStyle}
                    />
                  </Col>
                  <Col>
                    <Select
                      className="jirango-select"
                      options={
                        layouts
                          ? layouts.map((t) => {
                              return { value: t.meetingLayoutId, label: t.name };
                            })
                          : []
                      }
                      value={selectedLayout}
                      onChange={(opt) => {
                        const selLayout = layouts.find((e) => e.meetingLayoutId == opt.value);
                        setSelectedLayout({ value: selLayout.meetingLayoutId, label: selLayout.name });
                      }}
                      styles={selectorStyle}
                    />
                  </Col>
                  <Col>
                    <Button
                      startIcon={<AddIcon />}
                      className="secondary-dark-btn"
                      disabled={!selectedEvent && !selectedLayout}
                      onClick={() => addPresetItem(selectedEvent.value, selectedLayout.value, p.daPresetId)}
                    >
                      <SystemLabel name="Add" />
                    </Button>
                  </Col>
                </Row>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </List>
    </div>
  );
};
